export default {
    accept: 'Aceitar'
}